import { Collection } from "../ports.js";
/**
 * Collections kept once per phone and shared by everyone who signs in on it: the phone's own settings (who is signed
 * in, the language, the model) and the public city guides. Every other collection belongs to one owner.
 */
export const PHONE_COLLECTIONS = new Set([Collection.settings, Collection.guides]);
/** Every collection that belongs to one owner: the ones not kept per phone. */
export const OWNED_COLLECTIONS = Object.values(Collection).filter((c) => !PHONE_COLLECTIONS.has(c));
/** Between a collection's name and its owner's id; a user id (`usr_<ULID>`) never holds it. */
const OWNER_SEP = "@";
/** Where one owner's records of a collection are kept on the phone's storage. */
export const ownedName = (collection, owner) => `${collection}${OWNER_SEP}${owner}`;
/**
 * The phone's storage as one owner sees it. Phones are shared and an owner's records stay when they sign out, so
 * every owned collection is kept under its owner's name: whoever signs in next reads and writes only their own, and
 * sees the last owner's again only by signing in as them. Collections kept per phone pass through unchanged.
 */
export class OwnerStorage {
    base;
    owner;
    constructor(base, owner) {
        this.base = base;
        this.owner = owner;
    }
    name(collection) {
        return PHONE_COLLECTIONS.has(collection) ? collection : ownedName(collection, this.owner);
    }
    get(collection, id) {
        return this.base.get(this.name(collection), id);
    }
    put(collection, id, value) {
        return this.base.put(this.name(collection), id, value);
    }
    delete(collection, id) {
        return this.base.delete(this.name(collection), id);
    }
    list(collection) {
        return this.base.list(this.name(collection));
    }
    ids(collection) {
        return this.base.ids(this.name(collection));
    }
}
/** The ports one signed-in owner's agent, screens and stores use: the same phone, with storage seen as theirs. */
export function ownerPorts(ports, owner) {
    return { ...ports, storage: new OwnerStorage(ports.storage, owner) };
}
//# sourceMappingURL=storage.js.map